<template>
   <dashboard-layout :page="page">
      <base-breadcrumb :breadcrumbs="breadcrumbs"></base-breadcrumb>
      <v-container fluid>
         <v-row justify="center">
            <v-col cols="12" md="7">
               <v-card outlined>
                  <v-card-title>Nomination Consent</v-card-title>
                  <v-card-text v-if="!nomination">
                     <v-alert type="error" dense>Invalid or missing nomination data.</v-alert>
                  </v-card-text>
                  <v-card-text v-else>
                     <v-alert v-if="successMessage" type="success" dense>{{ successMessage }}</v-alert>
                     <v-alert v-if="errorMessage" type="error" dense v-html="errorMessage"></v-alert>
                     <v-alert v-if="isExpired && !successMessage" type="warning" dense>
                        Consent window for this position has ended ({{ formatDate(position ? position.dateend : null) }}).
                     </v-alert>

                     <v-row dense v-if="!successMessage">
                        <v-col cols="12" md="4"><small><b>Position</b></small></v-col>
                        <v-col cols="12" md="8"><small>{{ position ? position.title : '' }}</small></v-col>

                        <v-col cols="12" md="4"><small><b>You are nominated as</b></small></v-col>
                        <v-col cols="12" md="8"><small>{{ memberNominated ? memberNominated.fullname : '' }}</small></v-col>

                        <v-col cols="12" md="4"><small><b>Proposer</b></small></v-col>
                        <v-col cols="12" md="8"><small>{{ nomination.proposer }}</small></v-col>

                        <v-col cols="12" md="4"><small><b>Seconder</b></small></v-col>
                        <v-col cols="12" md="8"><small>{{ nomination.seconder }}</small></v-col>
                     </v-row>

                     <v-form v-if="!successMessage" v-model="isvalid" class="mt-4">
                        <v-text-field
                           v-model="tac"
                           label="TAC (from your email)"
                           maxlength="6"
                           :rules="[v => !!v || 'TAC is required']"
                           outlined
                           dense
                        ></v-text-field>
                     </v-form>
                  </v-card-text>
                  <v-card-actions v-if="nomination && !successMessage && !isExpired" class="px-4 pb-4">
                     <v-spacer></v-spacer>
                     <v-btn color="error" outlined :disabled="!tac || submitting" :loading="submitting && intent === 'decline'" @click="submit(false)">
                        Decline
                     </v-btn>
                     <v-btn color="primary" :disabled="!tac || submitting" :loading="submitting && intent === 'agree'" @click="submit(true)">
                        I Agree
                     </v-btn>
                  </v-card-actions>
               </v-card>
            </v-col>
         </v-row>
      </v-container>
   </dashboard-layout>
</template>

<script>
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
const axios = require('axios')

export default {
   name: 'MOMNomNominatedConsent',
   components: { DashboardLayout, BaseBreadcrumb },
   props: {
      position: { type: Object, default: null },
      nomination: { type: Object, default: null },
      member_nominated: { type: Object, default: null },
   },
   data() {
      return {
         page: { title: 'Nomination Consent', icon: 'mdi-account-check' },
         breadcrumbs: [
            { text: 'Dashboard', disabled: false, to: '/dashboard' },
            { text: 'Nomination Consent', disabled: true },
         ],
         tac: '',
         isvalid: false,
         submitting: false,
         intent: null,
         successMessage: '',
         errorMessage: '',
      }
   },
   computed: {
      memberNominated() {
         return this.member_nominated
      },
      isExpired() {
        if (!this.position || !this.position.dateend) return false
        return new Date(this.position.dateend) < new Date()
      }
   },
   methods: {
      formatDate(dateStr) {
         if (!dateStr) return ''
         return new Date(dateStr).toLocaleDateString()
      },
      submit(agree) {
         this.errorMessage = ''
         this.intent = agree ? 'agree' : 'decline'
         this.submitting = true
         axios.post('/member/nomination/nominated/consent/submit', {
            id: this.nomination.id,
            nomconsent: agree,
            tac: this.tac,
         })
            .then(({ data }) => {
               if (data.status !== 'OK') {
                  this.errorMessage = data.error || 'Unable to submit your response.'
                  return
               }
               this.successMessage = agree
                  ? 'Thank you. You have agreed to this nomination.'
                  : 'You have declined this nomination.'
            })
            .catch((error) => {
               this.errorMessage = error.response && error.response.data && error.response.data.message
                  ? error.response.data.message
                  : 'Unable to submit your response. Please try again.'
            })
            .finally(() => { this.submitting = false })
      },
   },
}
</script>